import i18n from './i18n';
import { GTINMetadata } from '@/contexts/item-context-types';
import { GtinMetadataFormatType } from '@/enums';

export interface GtinSettings {
  description_source_order: GtinMetadataFormatType[];
  name_source: GtinMetadataFormatType;
  photo_source_order: GtinMetadataFormatType[];
}

export const getGtinDescription = (
  gtinSettings: GtinSettings,
  gtinMetadata: GTINMetadata,
  itemDescription?: string | null,
): string | null => {
  return (
    gtinSettings.description_source_order
      .map((sourceOrder) => {
        switch (sourceOrder) {
          case GtinMetadataFormatType.Supplier:
            return itemDescription;
          case GtinMetadataFormatType.Syndigo:
            return gtinMetadata.description;
          default:
            return '';
        }
      })
      .filter(Boolean)
      .join('\n') ||
    itemDescription ||
    null
  );
};

export const getGtinPhotoUrlList = (
  gtinSettings: GtinSettings,
  gtinMetadata: GTINMetadata,
  itemPhotoList: string[],
): string[] => {
  const gtinUrls = gtinSettings.photo_source_order.flatMap((sourceOrder) => {
    switch (sourceOrder) {
      case GtinMetadataFormatType.Supplier:
        return itemPhotoList;
      case GtinMetadataFormatType.Syndigo:
        return gtinMetadata.item_image_urls || [];
      default:
        return [];
    }
  });
  return gtinUrls.length ? gtinUrls : itemPhotoList;
};

export const getGtinName = (
  gtinSettings: GtinSettings,
  gtinMetadata: GTINMetadata,
  itemName: string,
): string => {
  return gtinSettings.name_source === GtinMetadataFormatType.Syndigo &&
    gtinMetadata.item_name
    ? gtinMetadata.item_name
    : itemName;
};

export const getAllergenTranslation = (allergenName: string) => {
  return i18n.t(`allergen_code.${allergenName.toLowerCase()}`);
};

export const getTranslatedValue = (key: string, value: string | boolean) => {
  if (typeof value === 'boolean') {
    return value ? i18n.t('yes') : i18n.t('no');
  }

  switch (key) {
    case 'shelf_life_days':
      return i18n.t('shelf_life', { number: value });
    default:
      return value;
  }
};
